<app-switch-arrow></app-switch-arrow>

<h2>{{title}}</h2>